import { Accordion, AccordionTab } from 'primereact/accordion'
import React, { useEffect, useState, useCallback, useMemo, lazy, Suspense } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Api } from '../../../services/api'
import { Button } from 'primereact/button'
import { FaCopy, FaSync, FaCity, FaCalculator, FaHardHat, FaProjectDiagram, FaPaintRoller, FaLayerGroup, FaClipboardCheck, FaShieldAlt } from 'react-icons/fa'

import { TabView, TabPanel } from 'primereact/tabview';
import { IoArrowBackSharp } from 'react-icons/io5'

import "../../CRM/Leads/Leads.css";
import "../../Dashboard.css";

// Lazy load heavy components
const EditEstimating = lazy(() => import('../ESTIMATING/EditEstimating'));
// const EDIT_SP_TEMPLATE = lazy(() => import('./EDIT_SP_TEMPLATE'));
const EDIT_PM_TEMPLATE = lazy(() => import('./EDIT_PM_TEMPLATE'));

const EDIT_INTERIOR_DESIGN_TEMPLATE = lazy(() => import('../INTERIOR DESIGN TEMPLATE/EDIT_INTERIOR_DESIGN'));
const ConstructionAndInterior = lazy(() => import('../CONSTRUCTION AND INTERIOR/ConstructionAndInterior'));
const JOB_AUTOPSY = lazy(() => import('../JOB AUTOPSY/JOB_AUTOPSY'));
const WARRANTY = lazy(() => import('../WARRANTY/WARRANTY'));
const DEVELOPMENT_MANAGER_TEMPLATE = lazy(() => import('../DEVELOPMENT MANAGER TEMPLATE/DEVELOPMENT_MANAGER_TEMPLATE'));

const EDIT_All_PLAYBOOKS = () => {
   const navigate = useNavigate();
   const { proId } = useParams();
   const { pmTeId } = useParams();
   const [projectName, setProjectName] = useState('');
   const [isLoadingProject, setIsLoadingProject] = useState(true);

   useEffect(() => {
      getProjectDetails();

      // Prevent parent <main> from scrolling — this page handles its own scroll
      const mainEl = document.querySelector('main');
      if (mainEl) mainEl.style.overflow = 'hidden';
      return () => {
         if (mainEl) mainEl.style.overflow = '';
      };
   }, []);

   const getProjectDetails = useCallback(() => {
      var _body = {
         projectId: proId,
      }
      const token = localStorage.getItem('authToken');
      const headers = {
         'Content-Type': 'application/json',
         'Authorization': token ? `Bearer ${token}` : ''
      };
      fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
         method: "POST",
         body: JSON.stringify(_body),
         headers: headers
      })
         .then((response) => response.json())
         .then((response) => {
            setProjectName(response.project_name);
            setIsLoadingProject(false);
         })
         .catch((error) => {
            console.error("Error:", error);
            setIsLoadingProject(false);
         });
   }, [proId]);


   const renderHeader = useCallback((title, icon) => (
      <span className="tab-header-title">
         {/* {icon} */}
         <span className="text-center">{title}</span>
      </span>
   ), []);

   const handleRefresh = useCallback(() => {
      window.location.reload();
   }, []);

   const handleBack = useCallback(() => {
      navigate(-1);
      window.close();
   }, [navigate]);

   return (
      <div className="edit-playbooks-page">
         <div className="edit-playbooks-topbar dashboard-header fixed-header flex align-items-center justify-content-between p-3 border-bottom-1 surface-border">
            <Button
               type='button'
               onClick={handleBack}
               className='p-button-text p-button-secondary font-bold'
               icon={<IoArrowBackSharp className='mr-2' size={20} />}
            >
               Back
            </Button>

            <div className="text-center flex flex-column">
               {/* <span className="text-xl text-500">Project:</span> */}
               <span className="text-2xl font-bold text-900">{`Playbook: ${projectName}` || 'Loading...'}</span>
            </div>

            <Button
               className="copySave-button p-2"
               onClick={handleRefresh}
               type="button"
               tooltip="Refresh Page"
               tooltipOptions={{ position: 'bottom' }}
            >
               <FaSync className="mr-2" />
               Refresh
            </Button>
         </div>

         <div className="edit-playbooks-content">
            <TabView renderActiveOnly={true} className="custom-tabview">

               <TabPanel header={renderHeader(<>DEVELOPMENT<br />MANAGER</>, <FaCity />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Development Manager...</p></div>}>
                     <DEVELOPMENT_MANAGER_TEMPLATE pmId={proId} />
                  </Suspense>
               </TabPanel>

               <TabPanel header={renderHeader(<>PRECONSTRUCTION<br />MANAGER</>, <FaCalculator />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Preconstruction Manager...</p></div>}>
                     <EditEstimating ProjectIdEdit={proId} />
                  </Suspense>
               </TabPanel>

               {/* <TabPanel header={renderHeader(<>SUPERINTENDENT<br />CONSTRUCTION</>, <FaHardHat />)} title='Superintendent Construction' className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Superintendent...</p></div>}>
                     <EDIT_SP_TEMPLATE pmId={proId} />
                  </Suspense>
               </TabPanel> */}

               <TabPanel header={renderHeader(<>CONSTRUCTION<br />MANAGER</>, <FaProjectDiagram />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Construction Manager...</p></div>}>
                     <EDIT_PM_TEMPLATE pmId={proId} />
                  </Suspense>
               </TabPanel>

               <TabPanel header={renderHeader(<>INTERIOR<br />DESIGNER</>, <FaPaintRoller />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Interior Designer...</p></div>}>
                     <EDIT_INTERIOR_DESIGN_TEMPLATE pmId={proId} />
                  </Suspense>
               </TabPanel>

               <TabPanel header={renderHeader(<>CONS MANAGER<br />& INT DESIGNER</>, <FaLayerGroup />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Construction Manager & Interior Designer...</p></div>}>
                     <ConstructionAndInterior pmId={proId} />
                  </Suspense>
               </TabPanel>

               <TabPanel header={renderHeader(<>JOB<br />AUTOPSY</>, <FaClipboardCheck />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Job Autopsy...</p></div>}>
                     <JOB_AUTOPSY pmId={proId} />
                  </Suspense>
               </TabPanel>

               <TabPanel header={renderHeader(<>WARRANTY<br />TEMPLATE</>, <FaShieldAlt />)} className="accordian-header m-1">
                  <Suspense fallback={<div className="p-4 text-center"><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i><p>Loading Warranty Template...</p></div>}>
                     <WARRANTY pmId={proId} />
                  </Suspense>
               </TabPanel>

            </TabView>
         </div>

      </div>
   )
}

export default EDIT_All_PLAYBOOKS